"use client";

import Link from "next/link";
import { ChevronDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Stack } from "@/components/ui/stack";

import type { MenuNavigationItemProp } from "@/config/nav";
import { cn } from "@/lib/utils";

export function NavigationMenuItem({
  item,
  fullWidth = false,
}: {
  item: MenuNavigationItemProp;
  fullWidth?: boolean;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={item.variant ?? "link"}
          size="sm"
          className={cn("text-sm", fullWidth && "w-full")}
        >
          <Stack direction="row" align="center" gap={2}>
            {item.icon}
            {item.label}
            <ChevronDown size={16} />
          </Stack>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        {item.items.map((subItem) => (
          <DropdownMenuItem
            key={subItem.href}
            asChild
            className="cursor-pointer"
          >
            <Link href={subItem.href}>
              <Stack direction="row" align="center" gap={2}>
                {subItem.icon}
                {subItem.label}
              </Stack>
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
